<template>
  <vue-word-cloud
    v-if="!containsError()"
    :words="wordsData"
    :color="wordColour"
    font-family="Roboto"
    font-weight="bold"
    :spacing="0.15"
    :animation-overlap="1 / 2"
    :animation-duration="animationDuration"
  >
    <template slot-scope="{ text, weight }">
      <div
        :title="`${text}: ${weight}, click to exclude`"
        style="cursor: pointer"
        @click="excludeWord(text)"
      >
        {{ text }}
      </div>
    </template>
  </vue-word-cloud>
</template>

<script>
import VueWordCloud from 'vuewordcloud'
import { isEmpty, some, sample } from 'lodash'
import { mapState } from 'vuex'
import ChartMixin from '@/mixins/ChartMixin'
import ChartDataService from '@/services/ChartDataService'

export default {
  mixins: [ChartMixin],
  components: {
    [VueWordCloud.name]: VueWordCloud,
  },
  props: {
    listId: String,
    wordCloudColumns: Array,
    limit: String,
    embedded: String,
    smartUrlPrefix: String,
    filterQuery: String,
  },
  data() {
    return {
      wordsData: [],
      exclude: [],
      animationDuration: 1000,
    }
  },
  computed: {
    ...mapState({
      placeHolderMessage: (state) => state.ChartCategory.placeHolderMessage,
    }),
  },
  methods: {
    prepareForScreenShot(disable) {
      // We need to disable animation while taking the screenshot,
      // as otherwise words will start to overlap in the final image
      if (disable) {
        this.animationDuration = 0
      } else {
        this.animationDuration = 1000
      }
    },
    containsError() {
      return !isEmpty(this.placeHolderMessage) && !isEmpty(this.wordsData.placeHolderMessage)
    },
    chartContainsData() {
      if (some(this.wordCloudData, isEmpty)) {
        this.$store.dispatch('setPlaceHolderMessage', this.$t('message.nodata'))
      }
      return true
    },
    async loadWordCloudData(listId, wordCloudColumns, limit, exclude, searchAndFilterParams) {
      try {
        if (isEmpty(wordCloudColumns)) {
          await this.$store.dispatch('setPlaceHolderMessage', this.$t('message.nodata'))
          return
        }

        this.wordsData = (
          await ChartDataService.getWordCloudData(
            listId,
            wordCloudColumns,
            limit,
            exclude,
            searchAndFilterParams,
          )
        ).data
      } catch (error) {
        const message = error.response ? error.response.data : error
        const notification = { type: 'error', message }
        await this.$store.dispatch('Notification/add', notification, { root: true })
      } finally {
        const content = window.parent
        content.postMessage('vue-loaded', window.location.origin)
      }
    },
    loadData() {
      this.loadWordCloudData(
        this.listId,
        this.wordCloudColumns,
        this.limit,
        this.exclude,
        this.getJsonObject(this.filterQuery),
      )
    },
    emitLoaded() {
      if (!isEmpty(this.wordsData.placeHolderMessage)) {
        this.$store.dispatch('setPlaceHolderMessage', this.wordsData.placeHolderMessage)
      }
      this.$emit('loaded', !isEmpty(this.wordsData) && isEmpty(this.wordsData.placeHolderMessage))
      // Default animation duration + 100ms
      setTimeout(() => {
        this.isFullyRendered = true
      }, 1100)
    },
    wordColour() {
      const colours = [
        '#6B7280',
        '#EF4444',
        '#F59E0B',
        '#10B981',
        '#3B82F6',
        '#6366F1',
        '#8B5CF6',
        '#EC4899',
      ]
      return sample(colours)
    },
    excludeWord(word) {
      this.exclude.push(word)
      this.$emit('loading')
      this.loadData()
    },
  },
}
</script>
